// extracted by mini-css-extract-plugin
module.exports = {"shopTip":"TopTip_style_shopTip__1i_Aq","left":"TopTip_style_left__3Q08d","icon":"TopTip_style_icon__1Wc1G"};